import React from 'react';
import './DealFilters.css';

interface DealFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  typeFilter: string;
  onTypeFilterChange: (type: string) => void;
}

const DealFilters: React.FC<DealFiltersProps> = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  typeFilter,
  onTypeFilterChange,
}) => {
  return (
    <div className="deal-filters">
      <div className="deal-search">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search deals..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="deal-search-input"
        />
      </div>
      <div className="deal-filter-controls">
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="deal-filter-select"
        >
          <option>All Status</option>
          <option>Active</option>
          <option>Scheduled</option>
          <option>Paused</option>
          <option>Expired</option>
        </select>
        <select
          value={typeFilter}
          onChange={(e) => onTypeFilterChange(e.target.value)}
          className="deal-filter-select"
        >
          <option>All Types</option>
          <option>Percentage</option>
          <option>Fixed Amount</option>
          <option>Free Shipping</option>
          <option>BOGO</option>
        </select>
        <button className="deal-more-filters-btn">
          <span>🔽</span> More Filters
        </button>
      </div>
    </div>
  );
};

export default DealFilters;

